import { GESTAO_FEATURE, hasPermission, hasPlanFeature } from "../services/auth";

import Dashboard from '../pages/Dashboard';
import CreditOverview from '../pages/Credit';
import CreditStatement from '../pages/Credit/statement';
import CreditAllocation from '../pages/Credit/allocation';
import CreditAutoTopup from '../pages/Credit/autoTopup';
import ProductList from '../pages/Product/list';
import ProductEdit from '../pages/Product/edit';
import ProductCreate from '../pages/Product/create';
import ColorList from '../pages/Color/list';
import CategoryList from '../pages/Category/list';
import TagList from '../pages/Tag/list';
import CustomizationList from '../pages/Customization/list';
import CustomizationEdit from '../pages/Customization/edit';
import CompanyList from '../pages/Company/list';
import CompanyEdit from '../pages/Company/edit';
import BrandList from '../pages/Brand/list';
import BrandEdit from '../pages/Brand/edit';
import PersonalizedProduct from '../pages/Brand/PersonalizedProduct';
import CustomerList from '../pages/Customer/list';
import QuoteList from '../pages/Quote/list';
import QuoteEdit from '../pages/Quote/edit';
import OrderCreate from '../pages/Order/craete';
import OrderList from '../pages/Order/list';
import OrderEdit from '../pages/Order/edit';
import UserList from '../pages/User/list';
import Proposal from '../pages/Proposal';
import PageList from '../pages/Page';
import PageEdit from '../pages/Page/edit';
import PageCreate from '../pages/Page/create';
import BannerList from '../pages/Banner';
import LogoList from '../pages/Logo';
import TestimonialList from '../pages/Testimonial';
import Calculation from '../pages/Calculation';
import EmailTemplateEdit from '../pages/EmailTemplate/edit';
import EmailTemplateList from '../pages/EmailTemplate';
import { CustomerEdit } from '../pages/Customer/edit';
import StatusList from '../pages/Status/list';
import RoleList from '../pages/Role/list';
import Contact from "../pages/Contact";
import CompanyCategoryList from "../pages/Integration/Category/list";
import CRMList from "../pages/CRM";
import PipelinesList from "../pages/CRM/Pipelines";
import PipelineFormPage from "../pages/CRM/Pipelines/PipelineFormPage";
import CRMCard from "../pages/CRM/Card";
import MainTheme from "../pages/Theme";
import IntegrationList from "../pages/Integration";
import IntegrationDetail from "../pages/Integration/detail";
import FeedDetail from "../pages/Feed/detail";
import NotFound from "../pages/NotFound";
import BudgetForm from "../pages/BudgetForm";
import SiteFeatures from "../pages/SiteFeatures";
import Scripts from "../pages/Scripts";
import CrmAutomations from "../pages/CRM/Automations";
import CrmTags from "../pages/CRM/Tags";
import FinanceEntryList from "../pages/Finance/EntryList";
import FinanceOverview from "../pages/Finance/Overview";
import FinanceCashFlow from "../pages/Finance/CashFlow";
import FinanceStatement from "../pages/Finance/Statement";
import FinanceIncomeStatement from "../pages/Finance/IncomeStatement";
import FinanceReconciliation from "../pages/Finance/Reconciliation";
import FinanceSettings from "../pages/Finance/Settings";
import FinanceAutomations from "../pages/Finance/Automations";
import ReportList from "../pages/Report/list";
import ReportView from "../pages/Report/view";
import ReportEdit from "../pages/Report/edit";
import FiscalSettings from "../pages/Fiscal/Settings";
import FiscalDocumentList from "../pages/Fiscal/DocumentList";
import FiscalIssueDocument from "../pages/Fiscal/IssueDocument";
import FiscalOperationList from "../pages/Fiscal/Operations/list";
import FiscalOperationEdit from "../pages/Fiscal/Operations/edit";
import PurchaseOrderList from "../pages/PurchaseOrder/list";
import PurchaseInvoiceList from "../pages/PurchaseInvoice/list";
import DfeInvoiceList from "../pages/PurchaseInvoice/inbox";
import DomainSettings from "../pages/Settings/DomainSettings";
import PaymentConditions from "../pages/PaymentConditions";
import ToolsList from "../pages/Tools";
import SettingsHub from "../pages/Settings/Hub";
import Subscription from "../pages/Subscription";

export const privateRoutes = [
    {
        path: "/ferramentas",
        element: <ToolsList />,
        show: false,
        main: true
    },
    {
        path: "/dashboard",
        element: <Dashboard />,
        show: hasPermission(['view_unrelated_dashboard', 'view_related_dashboard']),
        main: true
    },
    {
        path: "/product/list",
        element: <ProductList />,
        show: hasPermission('view_product'),
        main: true
    },
    {
        path: "/product/edit/:id",
        element: <ProductEdit />,
        show: true, // para sempre ser possível visualizar
        main: false
    },
    {
        path: "/product/create",
        element: <ProductCreate />,
        show: hasPermission('create_product'),
        main: false
    },
    {
        path: "/color/list",
        element: <ColorList />,
        show: hasPermission('view_color'),
        main: true
    },
    {
        path: "/category/list",
        element: <CategoryList />,
        show: hasPermission('view_category'),
        main: true
    },
    {
        path: "/tag/list",
        element: <TagList />,
        show: hasPermission('view_tag'),
        main: true
    },
    {
        path: "/customization/list",
        element: <CustomizationList />,
        show: hasPermission('view_customization'),
        main: true
    },
    {
        path: "/customization/edit/:id",
        element: <CustomizationEdit />,
        show: hasPermission('edit_customization'),
        main: false
    },
    {
        path: "/crm",
        element: <PipelinesList />,
        show: true,
        main: true
    },
    {
        path: "/finance/overview",
        element: <FinanceOverview />,
        show: hasPermission(['view_finance', 'manage_finance']),
        module: GESTAO_FEATURE,
        main: true
    },
    {
        path: "/finance/receivables",
        element: <FinanceEntryList key="receivables" type="receivable" />,
        show: hasPermission(['view_finance', 'manage_finance']),
        module: GESTAO_FEATURE,
        main: true
    },
    {
        path: "/finance/payables",
        element: <FinanceEntryList key="payables" type="payable" />,
        show: hasPermission(['view_finance', 'manage_finance']),
        module: GESTAO_FEATURE,
        main: false
    },
    {
        path: "/finance/statement",
        element: <FinanceStatement />,
        show: hasPermission(['view_finance', 'manage_finance']),
        module: GESTAO_FEATURE,
        main: false
    },
    {
        path: "/finance/cash-flow",
        element: <FinanceCashFlow />,
        show: hasPermission(['view_finance', 'manage_finance']),
        module: GESTAO_FEATURE,
        main: false
    },
    {
        path: "/finance/reconciliation",
        element: <FinanceReconciliation />,
        show: hasPermission(['view_finance', 'manage_finance']),
        module: GESTAO_FEATURE,
        main: false
    },
    {
        path: "/finance/income-statement",
        element: <FinanceIncomeStatement />,
        show: hasPermission(['view_finance', 'manage_finance']),
        module: GESTAO_FEATURE,
        main: false
    },
    {
        path: "/finance/settings",
        element: <FinanceSettings />,
        show: hasPermission('manage_finance'),
        module: GESTAO_FEATURE,
        main: false
    },
    {
        path: "/finance/automations",
        element: <FinanceAutomations />,
        show: hasPermission(['view_finance', 'manage_finance']),
        module: GESTAO_FEATURE,
        main: false
    },
    {
        path: "/report",
        element: <ReportList />,
        show: hasPermission(['view_finance', 'manage_finance']),
        module: GESTAO_FEATURE,
        main: true
    },
    {
        path: "/report/new",
        element: <ReportEdit />,
        show: hasPermission(['view_finance', 'manage_finance']),
        module: GESTAO_FEATURE,
        main: false
    },
    {
        path: "/report/:id",
        element: <ReportView />,
        show: hasPermission(['view_finance', 'manage_finance']),
        module: GESTAO_FEATURE,
        main: false
    },
    {
        path: "/report/:id/edit",
        element: <ReportEdit />,
        show: hasPermission(['view_finance', 'manage_finance']),
        module: GESTAO_FEATURE,
        main: false
    },
    {
        path: "/purchase-order/list",
        element: <PurchaseOrderList />,
        show: hasPermission(['view_purchase_order', 'manage_purchase_order']),
        module: GESTAO_FEATURE,
        main: false
    },
    {
        path: "/purchase-invoice/list",
        element: <PurchaseInvoiceList />,
        show: hasPermission(['view_purchase_order', 'manage_purchase_order']),
        module: GESTAO_FEATURE,
        main: false
    },
    {
        path: "/purchase-invoice/sefaz",
        element: <DfeInvoiceList />,
        show: hasPermission(['view_purchase_order', 'manage_purchase_order']),
        module: GESTAO_FEATURE,
        main: false
    },
    {
        path: "/fiscal/documents",
        element: <FiscalDocumentList />,
        show: hasPermission(['view_fiscal', 'manage_fiscal']),
        module: GESTAO_FEATURE,
        main: false
    },
    {
        path: "/fiscal/documents/new",
        element: <FiscalIssueDocument />,
        show: hasPermission('manage_fiscal'),
        module: GESTAO_FEATURE,
        main: false
    },
    {
        path: "/fiscal/settings",
        element: <FiscalSettings />,
        show: hasPermission(['view_fiscal', 'manage_fiscal']),
        module: GESTAO_FEATURE,
        main: false
    },
    {
        // Nota pendente abre para editar; nota já enviada, só para consulta.
        path: "/fiscal/documents/:id",
        element: <FiscalIssueDocument />,
        show: hasPermission(['view_fiscal', 'manage_fiscal']),
        module: GESTAO_FEATURE,
        main: false
    },
    {
        path: "/fiscal/operations",
        element: <FiscalOperationList />,
        show: hasPermission(['view_fiscal', 'manage_fiscal']),
        module: GESTAO_FEATURE,
        main: false
    },
    {
        path: "/fiscal/operations/new",
        element: <FiscalOperationEdit />,
        show: hasPermission('manage_fiscal'),
        module: GESTAO_FEATURE,
        main: false
    },
    {
        path: "/fiscal/operations/:id",
        element: <FiscalOperationEdit />,
        show: hasPermission(['view_fiscal', 'manage_fiscal']),
        module: GESTAO_FEATURE,
        main: false
    },
    {
        path: "/crm/painel/novo",
        element: <PipelineFormPage />,
        show: true,
        main: false
    },
    {
        path: "/crm/painel/:id/editar",
        element: <PipelineFormPage />,
        show: true,
        main: false
    },
    {
        path: "/crm/painel/:id",
        element: <CRMList />,
        show: true,
        main: false
    },
    {
        path: "/crm/card/:id",
        element: <CRMCard />,
        show: true,
        main: false
    },
    {
        path: "/crm/automacoes",
        element: <CrmAutomations />,
        show: hasPermission('edit_crm_settings'),
        main: false
    },
    {
        path: "/crm/automacoes/painel/:pipelineId",
        element: <CrmAutomations />,
        show: hasPermission('edit_crm_settings'),
        main: false
    },
    {
        path: "/crm/etiquetas",
        element: <CrmTags />,
        show: hasPermission('edit_crm_settings'),
        main: false
    },
    {
        path: "/company/list",
        element: <CompanyList />,
        show: true,
        main: true
    },
    {
        path: "/company/edit/:id",
        element: <CompanyEdit />,
        show: true,
        main: false
    },
    {
        path: "/brand/list",
        element: <BrandList />,
        show: hasPermission('view_brand'),
        main: true
    },
    {
        path: "/brand/create",
        element: <BrandEdit />,
        show: hasPermission('create_brand'),
        main: false
    },
    {
        path: "/brand/edit/:id",
        element: <BrandEdit />,
        show: hasPermission('view_brand'),
        main: false
    },
    {
        path: "/brand/:id/personalized/:productId",
        element: <PersonalizedProduct />,
        show: hasPermission('view_brand'),
        main: false
    },
    {
        path: "/customer/list",
        element: <CustomerList />,
        show: hasPermission(['view_unrelated_customer', 'view_related_customer']),
        main: true
    },
    {
        path: "/customer/edit/:id",
        element: <CustomerEdit />,
        show: true,
        main: false
    },
    {
        path: "/integration/list",
        element: <IntegrationList />,
        show: true,
        main: true
    },
    {
        path: "/integration/detail/:id",
        element: <IntegrationDetail />,
        show: true,
        main: false
    },
    {
        path: "/feed/:slug",
        element: <FeedDetail />,
        show: true,
        main: false
    },
    {
        path: "/credits",
        element: <CreditOverview />,
        show: hasPermission(['view_credits', 'manage_credits']),
        main: true
    },
    {
        path: "/credits/extrato",
        element: <CreditStatement />,
        show: hasPermission(['view_credits', 'manage_credits']),
        main: false
    },
    {
        path: "/credits/distribuicao",
        element: <CreditAllocation />,
        show: hasPermission('manage_credits'),
        main: false
    },
    {
        path: "/credits/recarga",
        element: <CreditAutoTopup />,
        show: hasPermission('manage_credits'),
        main: false
    },
    {
        path: "/quote/list",
        element: <QuoteList />,
        show: true,
        main: true
    },
    {
        path: "/quote/edit/:id",
        element: <QuoteEdit />,
        show: true,
        main: false
    },
    {
        path: "/proposal/:id",
        element: <Proposal />,
        show: true,
        main: false
    },
    {
        path: "/order/list",
        element: <OrderList />,
        show: true,
        main: true
    },
    {
        path: "/order/create/:id",
        element: <OrderCreate />,
        show: true,
        main: false
    },
    {
        path: "/order/edit/:id",
        element: <OrderEdit />,
        show: true,
        main: false
    },
    {
        path: "/user/list",
        element: <UserList />,
        show: true,
        main: true
    },
    {
        path: "/role/list",
        element: <RoleList />,
        show: true,
        main: true
    },
    {
        path: "/page/list",
        element: <PageList />,
        show: true,
        main: true
    },
    {
        path: "/page/create",
        element: <PageCreate />,
        show: true,
        main: false
    },
    {
        path: "/page/edit/:id",
        element: <PageEdit />,
        show: true,
        main: false
    },
    {
        path: "/email-template/list",
        element: <EmailTemplateList />,
        show: true,
        main: true
    },
    {
        path: "/email-template/edit/:id",
        element: <EmailTemplateEdit />,
        show: true,
        main: false
    },
    {
        path: "/banner/list",
        element: <BannerList />,
        show: true,
        main: true
    },
    {
        path: "/logo/list",
        element: <LogoList />,
        show: true,
        main: true
    },
    {
        path: "/testimonial/list",
        element: <TestimonialList />,
        show: true,
        main: true
    },
    {
        path: "/calculation",
        element: <Calculation />,
        show: true,
        main: true
    },
    {
        path: "/company/categories",
        element: <CompanyCategoryList />,
        show: true,
        main: true
    },
    {
        path: "/status/list",
        element: <StatusList />,
        show: hasPermission('status'),
        main: true
    },
    {
        path: "/contact",
        element: <Contact />,
        show: true,
        main: true
    },
    {
        path: "/theme",
        element: <MainTheme view="identity" />,
        show: true,
        main: true
    },
    {
        path: "/theme/site",
        element: <MainTheme view="theme" />,
        show: true,
        main: true
    },
    {
        path: "/theme/seo",
        element: <MainTheme view="seo" />,
        show: true,
        main: true
    },
    {
        path: "/scripts",
        element: <Scripts />,
        show: true,
        main: true
    },
    {
        path: "/site/formulario-orcamento",
        element: <BudgetForm />,
        show: true,
        main: true
    },
    {
        path: "/site/recursos",
        element: <SiteFeatures />,
        show: true,
        main: true
    },
    {
        path: "/assinatura",
        element: <Subscription />,
        show: true,
        main: false
    },
    {
        path: "/settings",
        element: <SettingsHub />,
        show: true,
        main: false
    },
    {
        path: "/settings/crm",
        element: <CrmAutomations />,
        show: hasPermission('edit_crm_settings'),
        main: true
    },
    {
        path: "/settings/payment-conditions",
        element: <PaymentConditions />,
        show: true,
        main: true
    },
    {
        path: "/settings/domain",
        element: <DomainSettings />,
        show: hasPermission('configure_domain'),
        main: true
    },
    {
        path: "/404",
        element: <NotFound />,
        show: true,
        main: false
    },
];

export const getInitialPath = () => {
    let path = null;

    for(let i = 0; i < privateRoutes.length; i++){
        console.log(privateRoutes, path = privateRoutes[i].path, privateRoutes[i].show && privateRoutes[i].main)
        if(privateRoutes[i].show && privateRoutes[i].main){
            path = privateRoutes[i].path;
            break;
        }
    }
    
    return path;
}

export default privateRoutes;
